// High-level file operations for S3-compatible storage.

import { S3Client } from './client';
const IMAGE_EXTENSIONS = ['jpg', 'jpeg', 'png', 'gif', 'webp', 'svg', 'ico', 'bmp'];
// S3 has no real directories — "folders" are emulated via key prefixes.
// A UI path like "/images/" maps to the key prefix "images/", and the
// bucket root ("/") maps to the empty prefix.
function pathToPrefix(path) {
  if (!path || path === '/') return '';
  return path.replace(/^\/+/, '').replace(/\/*$/, '/');
}
export class S3FileManager {
  constructor({
    edgeBaseUrl,
    getAccessToken,
    getActiveSiteId,
    publicUrlPrefix
  }) {
    this.client = new S3Client({
      edgeBaseUrl,
      getAccessToken,
      getActiveSiteId
    });
    this.publicUrlPrefix = publicUrlPrefix;
  }
  async listFiles(path = '/') {
    try {
      return await this.client.listAllObjects(pathToPrefix(path));
    } catch (error) {
      console.error('Error listing files:', error);
      throw error;
    }
  }
  filterImageFiles(files) {
    return files.filter(file => {
      if (file.IsDirectory) return false;
      const ext = file.ObjectName.split('.').pop()?.toLowerCase();
      return ext && IMAGE_EXTENSIONS.includes(ext);
    });
  }
  async getFilesWithUrls(path = '/', imagesOnly = false) {
    const files = await this.listFiles(path);
    const filtered = imagesOnly ? this.filterImageFiles(files) : files;
    return filtered.map(file => ({
      ...file,
      publicUrl: this.client.generatePublicUrl(this.publicUrlPrefix, file.Key)
    }));
  }
  async uploadFile(filePath, file, fileName) {
    try {
      const key = `${pathToPrefix(filePath)}${fileName}`;
      await this.client.uploadFile(key, file);
      return this.client.generatePublicUrl(this.publicUrlPrefix, key);
    } catch (error) {
      console.error('Error uploading file:', error);
      throw error;
    }
  }
  async deleteFile(key) {
    try {
      await this.client.deleteFile(key);
    } catch (error) {
      console.error('Error deleting file:', error);
      throw error;
    }
  }
  getParentPath(currentPath) {
    if (currentPath === '/') return '/';
    const parts = currentPath.split('/').filter(p => p);
    parts.pop();
    return parts.length === 0 ? '/' : `/${parts.join('/')}/`;
  }
  normalizePath(path) {
    if (!path || path === '') return '/';
    if (!path.startsWith('/')) path = '/' + path;
    if (path !== '/' && !path.endsWith('/')) path = path + '/';
    return path.replace(/\/+/g, '/');
  }
}